import React from 'react';

export default function RefiEligibilityFailureCard({ reason, body }) {
  const defaultBody = 'This customer is not eligible for a refinance at this time.';
  return (
    <div className="notification is-danger is-light">
      <h3 className="title is-size-5 mb-1">Not Eligible</h3>
      <p className="is-size-6">
        {body ?? defaultBody}
        {reason && (
          <span className="is-block mt-2">
            <strong>Reason:</strong> {reason}
          </span>
        )}
      </p>
    </div>
  );
}
